import EditComment from './EditComment.container';

export default EditComment;
